import { useContext } from "react"
import { LateSubmissionViewContext } from "../../context/LateSubmissionViewContext"
import { FormLoader } from "../Loader/FormLoader"
import { FormattedMessage } from "react-intl"
import { singleLateSubmissionStyles } from './Styles'
import { formStyles } from '../Invoice/Steps/FormStyles'
import { useStyles as pageHeaderStyles } from '../PageTitle/Styles'
import {
    Button,
    InputLabel,
    Paper
} from '@material-ui/core'
import { Link } from 'react-router-dom'
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace'
import { LanguageContext } from "../../context/LanguageContext"
import { NamedRoutes } from "../../routes"
import 'moment/locale/ar-sa'
import Moment from "react-moment"
const SingleLateSubmissionPageContent = () => {

    const { locale } = useContext(LanguageContext)
    const { lateSubmissionData, lateSubmissioneDataLoading } = useContext(LateSubmissionViewContext)
    const formClasses = formStyles()
    const lateSubmissionClasses = singleLateSubmissionStyles()
    const classes = pageHeaderStyles()

    const getColumnValue = (key, value) => {

        if (!!key) {
            switch (key) {
                case 'reasonId':
                    return <div className={formClasses.FormItem} key={key}>
                        <InputLabel>
                            <FormattedMessage
                                id={`Fields.label.view.lateSubmission.reason`} />:</InputLabel>
                        <div className={'info-data'}>
                            <strong>{locale === 'ar' ? value?.nameAr : value?.nameEn}</strong>
                        </div>
                    </div>
                case 'activationDate':
                case 'expiryDate':
                    return <div className={formClasses.FormItem} key={key}>
                        <InputLabel>
                            <FormattedMessage
                                id={`Fields.label.view.lateSubmission.${key.toString().toLowerCase()}`} />:</InputLabel>
                        <div className={'info-data'}>
                            {/* <strong>{locale === 'ar' ? value?.nameAr : value?.nameEn}</strong> */}
                            <Moment locale={locale === 'ar' ? 'ar-sa' : 'en-us'}
                                format={locale === 'ar' ? 'YYYY/MM/DD' : 'DD/MM/YYYY'}>{value}</Moment>
                        </div>
                    </div>
                default:
                    return !!value && <div className={formClasses.FormItem} key={key}>
                        <InputLabel>
                            <FormattedMessage
                                id={`Fields.label.view.lateSubmission.${key.toString().toLowerCase()}`} />:</InputLabel>
                        <div className={'info-data'}>
                            <strong>{value}</strong>
                        </div>
                    </div>
            }
        } else {
            return ''
        }
    }
    return (
        <>
            <Button size={'medium'} variant={'text'} color={'secondary'} component={Link} to={NamedRoutes.lateSubmission}
                className={classes.backBtn} disableRipple disableElevation>
                <KeyboardBackspaceIcon className={locale === 'ar' ? 'flip-direction' : ''} /> <FormattedMessage
                    id='LateSubmission.BackButton.Title' />
            </Button>
            {!!lateSubmissioneDataLoading && <FormLoader loading={true} />}
            <Paper elevation={0} className={lateSubmissionClasses.lateSubmissionDataWrapper}>
                <div className={formClasses.EntityInfoWrapper}>

                    {!!Object.keys(lateSubmissionData).length && Object.keys(lateSubmissionData)?.map((column, index) => (
                        <>
                            {["reasonId", "reason", "activationDate", "expiryDate", "userid"].includes(column) ?
                                getColumnValue(column, lateSubmissionData[column])
                                :
                                <div className={formClasses.FormItem} key={column}>
                                    <InputLabel>
                                        <FormattedMessage
                                            id={`Fields.label.view.lateSubmission.${column.toString().toLowerCase()}`} />:</InputLabel>
                                    <div className={'info-data'}>
                                        <strong>{lateSubmissionData[column]}</strong>
                                    </div>

                                </div>
                            }
                        </>
                    ))
                    }
                </div>
            </Paper>
        </>
    )
}

export default SingleLateSubmissionPageContent